module.exports = __webpack_public_path__ + "static/media/Mariachi_Form_4.d52c29b4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Mariachi_Form_4.pdf
// module id = 236
// module chunks = 0